import React from 'react';
import { Link } from '@americanexpress/dls-react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import { formatDate } from '../../../utils/abandonCartUtils';
import { postContextFeedbackThunk } from '../../../thunks/postContextFeedbackThunk';
import { getHotelDeepLinksUrl } from '../../../selectors/getContextApiSelectors';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';

const ContinueButton = ({ triggerAnalytics, buttonTextLocaleId }) => {
  const dispatch = useDispatch();
  const isDesktop = useMediaBreakpoint('lg-up');
  const { formatMessage } = useIntl();
  const {
    data: abandonCartData,
  } = useAbandonCartData();
  const {
    tripStartDate,
    tripEndDate,
    hotelProductSelected,
    hotelRoomType,
    hotelId,
  } = abandonCartData;

  const hotelDetailDeepLink = useSelector(getHotelDeepLinksUrl({
    hotelId,
    tripStartDate,
    tripEndDate,
    hotelRoomType,
  }));

  return (
    <Link
      id="abandonHotelContinueButton"
      aria-describedby={
        `${formatMessage({ id: 'abandonHotel.finish' })} ${hotelProductSelected} ${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`
      }
      href={hotelDetailDeepLink}
      target="_blank"
      inline={true}
      rel="noopener noreferrer"
      className={clsx(
        'flex flex-align-items-center flex-justify-center text-align-center btn btn-sm btn-secondary',
        !isDesktop ? 'width-full margin-1' : 'pad-1'
      )}
      style={{
        textDecoration: 'none',
        textOverflow: 'initial',
      }}
      onClick={(event) => {
        event.stopPropagation();
        triggerAnalytics('continue');
        dispatch(postContextFeedbackThunk({ abandonCartData }));
      }}
    >
      {formatMessage({ id: buttonTextLocaleId })}
    </Link>
  );
};

ContinueButton.propTypes = {
  triggerAnalytics: PropTypes.func.isRequired,
  buttonTextLocaleId: PropTypes.string.isRequired,
};

export default ContinueButton;
